import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import type { ListFormTab } from '../../../../types/form.types'

export interface ListFormTabsBarProps {
  tabs: ListFormTab[] | undefined
  tabIndex: number
  onTabChange: (index: number) => void
}

/** List-form category tabs — same chrome as App mode (`RuntimeListView`). */
export function ListFormTabsBar({ tabs, tabIndex, onTabChange }: ListFormTabsBarProps) {
  if (!tabs?.length) return null
  return (
    <Tabs
      value={tabIndex}
      onChange={(_, v) => onTabChange(v)}
      aria-label="List tabs"
      sx={{ px: 2, borderBottom: 1, borderColor: 'divider', minHeight: 42, bgcolor: 'background.paper' }}
    >
      {tabs.map((tb, i) => (
        <Tab key={`${tb.label}-${i}`} label={tb.label} sx={{ textTransform: 'none', fontSize: 13, minHeight: 40 }} />
      ))}
    </Tabs>
  )
}
